import React from 'react'
import Button from '../../forms/blackfillButton'
import { useState } from 'react'

const SharePopup = ({Active,SetActive,Path}) => {
    const [copyText, setCopyText] = useState('Copy');
  return (
    <>
        {Active === 1 &&
            <div className='top_settings_popup active'>
                <div className='top_settings_popup_container active'>
                    <div className='sharebox_pop_container'>
                        <input 
                            className="primary_input" 
                            type="text"
                            value={"https://kaay.pk/"+Path}
                            readOnly={true}
                        />
                        <Button Value={copyText} Action={()=>{
                            setCopyText("Copied!");
                            navigator.clipboard.writeText("https://kaay.pk/"+Path);
                            setTimeout(() => {
                                setCopyText("Copy");
                            }, 3000);
                        }}/>
                    </div>
                
                </div>
                <div className='top_settings_popup_closer' onClick={()=>{SetActive(0)}}></div>
            </div>
        }
    </>
  )
}

export default SharePopup
